import { useState } from 'react';
import { supabase } from '@/lib/supabase';

export interface NutrientSource {
  product: string;
  weight_g: number;
  amount: number;
}

export interface NutrientItem {
  name: string;
  amount: number;
  unit: string;
  daily_percent: number;
  level: 'normal' | 'good' | 'excellent' | 'very_high';
  description: string;
  sources?: NutrientSource[];  // Разбивка по продуктам
}

// 🆕 Главные выводы — 3 смысловых блока сверху модалки
export interface KeyTakeaway {
  icon: string;       // Эмодзи-икона (💪, ⚡, ⚠️)
  title: string;      // Короткий заголовок (3-6 слов)
  description: string; // Описание 1-2 предложения с контекстом
}

export interface NutrientsData {
  key_takeaways?: KeyTakeaway[];  // 🆕 3 главных вывода
  items: NutrientItem[];
  wow: string | null;
  warning: string | null;
  summary_keywords: string[];
  pending?: boolean;
}

export function useNutrients() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<NutrientsData | null>(null);
  const [error, setError] = useState<string | null>(null);
  async function fetchNutrients(params: {
    mealId?: string;
    items: Array<{ name: string; weight_g?: number; estimated_weight_g?: number }>;
  }) {
    setLoading(true);
    setError(null);
    try {
      const { data: { session } } = await supabase.auth.getSession();
      const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
      const res = await fetch(
        `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/analyze-nutrients`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${session?.access_token || anonKey}`,
            'apikey': anonKey,
          },
          body: JSON.stringify(params),
        }
      );
      const result = await res.json();
      
      if (result.error) {
        throw new Error(result.error);
      }
      setData(result as NutrientsData);
      return result as NutrientsData;
    } catch (e: any) {
      console.error('Nutrients fetch error:', e);
      setError(e.message || 'Не удалось загрузить');
      return null;
    } finally {
      setLoading(false);
    }
  }
  return { fetchNutrients, loading, data, error };
}
